import PocketBase from "pocketbase";

// PocketBase lives on its own subdomain to avoid path-prefix rewriting
// issues with the OAuth2 SDK flow. Override for local dev via VITE_PB_URL.
const PB_BASE = import.meta.env.VITE_PB_URL ?? "https://pb.console.thinkler.ai";

export const pb = new PocketBase(PB_BASE);
pb.autoCancellation(false);

export function isAuthenticated(): boolean {
  return pb.authStore.isValid;
}

export async function loginWithGoogle(): Promise<void> {
  await pb.collection("users").authWithOAuth2({ provider: "google" });
}

export async function logout(): Promise<void> {
  pb.authStore.clear();
}
